import { Component, computed, input } from '@angular/core';
import { groupBy } from '@app/utils/common';
import { currentLanguage } from '@app/utils/translate';
import { NotificationItemComponent } from '@business/notification/components/notification-item/notification-item.component';
import {
  getTranslationsByKey,
  PortalNotificationLike,
  PortalNotificationTranslationLike,
} from '@business/notification/models/portal-notification-helpers';

@Component({
  selector: 'portal-notification-live-view-item',
  standalone: true,
  imports: [NotificationItemComponent],
  template: ` @for (translation of currentTranslations(); track translation.orderIndex) {
    <portal-notification-item
      [class.title]="translation.orderIndex === 0"
      [showImage]="(translation.orderIndex === 0 && showTitleImage()) || translation.orderIndex > 0"
      [showTitle]="(translation.orderIndex === 0 && showTitle()) || translation.orderIndex > 0"
      [translation]="translation"
    />
  }`,
  styles: `
    :host {
      portal-notification-item:last-child portal-rich-text .content > :last-child {
        margin-block-end: 0;
      }
    }
  `,
})
export class NotificationLiveViewItemComponent {
  language = input<string>();
  notification = input<PortalNotificationLike>();
  showTitle = input<boolean>(true);
  showTitleImage = input<boolean>(true);
  translations = input<PortalNotificationTranslationLike[]>();

  currentLanguage = currentLanguage();
  activeLanguage = computed(() => this.language() ?? this.currentLanguage());
  currentTranslations = computed(() => {
    // Translations trump notification
    if (this.translations() != null) {
      let translations = this.translations();

      if (this.showTitle() === false) {
        translations = translations.filter((translation) => translation.orderIndex > 0);
      }

      return translations;
    }

    const byLanguage = groupBy(this.notification().translations, (translation) => translation.language);
    let translations = getTranslationsByKey(byLanguage, this.activeLanguage());

    if (this.showTitle() === false) {
      translations = translations.filter((translation) => translation.orderIndex !== 0);
    }

    return translations;
  });
}
